import React from 'react';
import {Button, Card} from 'react-bootstrap';
import { BsExclamationTriangleFill } from "react-icons/bs";

type Props = {
    showReset?: boolean;
    handleReload?: () => void;
    handleReset?: () => void;
};

const FallBackComponent: React.FC<Props> = ({showReset, handleReload, handleReset}) => (
    <Card className="shadow-lg bg-white rounded-4">
        <Card.Title className="d-flex flex-row justify-content-center">
            <BsExclamationTriangleFill size={25} className="errorImage" />
        </Card.Title>
        <Card.Body className="d-flex flex-column justify-content-center align-items-center mt-0 mb-0">
            <h6 className="font-sub errorText">
                Oops. Something went wrong.
                Please download our Mobile App for quick ordering or try again.
            </h6>
            <div className="d-flex flex-row justify-content-between align-items-center">
                {showReset && (
                    <Button className="m-3 secondary-button" onClick={handleReset}>
                        Reset
                    </Button>
                )}
                <Button className="m-3 order-now-card-button" onClick={handleReload}>
                    Try Again
                </Button>
            </div>
        </Card.Body>
    </Card>
);

export default FallBackComponent;
